<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-dot-drag`]" width="1em" height="1em" v-bind="$attrs"><path d="M5.25 12.25C5.94036 12.25 6.5 12.8096 6.5 13.5C6.5 14.1904 5.94036 14.75 5.25 14.75C4.55964 14.75 4 14.1904 4 13.5C4 12.8096 4.55964 12.25 5.25 12.25ZM10.75 12.25C11.4404 12.25 12 12.8096 12 13.5C12 14.1904 11.4404 14.75 10.75 14.75C10.0596 14.75 9.5 14.1904 9.5 13.5C9.5 12.8096 10.0596 12.25 10.75 12.25ZM5.25 6.75C5.94036 6.75 6.5 7.30964 6.5 8C6.5 8.69036 5.94036 9.25 5.25 9.25C4.55964 9.25 4 8.69036 4 8C4 7.30964 4.55964 6.75 5.25 6.75ZM10.75 6.75C11.4404 6.75 12 7.30964 12 8C12 8.69036 11.4404 9.25 10.75 9.25C10.0596 9.25 9.5 8.69036 9.5 8C9.5 7.30964 10.0596 6.75 10.75 6.75ZM5.25 1.25C5.94036 1.25 6.5 1.80964 6.5 2.5C6.5 3.19036 5.94036 3.75 5.25 3.75C4.55964 3.75 4 3.19036 4 2.5C4 1.80964 4.55964 1.25 5.25 1.25ZM10.75 1.25C11.4404 1.25 12 1.80964 12 2.5C12 3.19036 11.4404 3.75 10.75 3.75C10.0596 3.75 9.5 3.19036 9.5 2.5C9.5 1.80964 10.0596 1.25 10.75 1.25Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineDotDrag',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
